import * as z from 'zod';

import { TableRowColors } from '@/common/constants';

const TableRowColorsSchema = z.enum([
  TableRowColors.GREEN,
  TableRowColors.DARK_GREEN,
  TableRowColors.YELLOW,
  TableRowColors.LIGHT_BLUE,
  TableRowColors.DARK_BLUE,
  TableRowColors.TEAL,
  TableRowColors.ORANGE,
  TableRowColors.RED,
]);

export default TableRowColorsSchema;
